import { render } from "./Modal.vue?vue&type=template&id=559c971a&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=559c971a&scoped=true&lang=css"

import exportComponent from "/builds/alex-yonge-photography/alex-yonge-photographs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559c971a"]])

export default __exports__